import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import appSelectors from '@/redux/app/appSelectors';

import tags from './tags';

const APP_URL = import.meta.env.VITE_APP_URL;

function HeadTags() {
  const { pathname } = useLocation();

  const lang = useSelector(appSelectors.language);

  return (
    <>
      <title>{tags[pathname]?.title[lang] || tags['/'].title[lang]}</title>
      <meta
        name="description"
        content={
          tags[pathname]?.description[lang] || tags['/'].description[lang]
        }
      />
      <meta
        name="keywords"
        content={tags[pathname]?.keywords[lang] || tags['/'].keywords[lang]}
      />
      <link rel="canonical" href={`${APP_URL}${pathname}`} />
    </>
  );
}

export default HeadTags;
